import { ApiService } from "@/api";

export const getLittleGroupDetailLeader = (groupId: string) => {
  return ApiService.baseAction(`/little-group/${groupId}/list`, {}, 'get');
}